import React from 'react'

const TopBehaviors = ({ data }) => {
  // Extract all behavior columns
  const behaviorFields = ['Behaviors L1', 'Behaviors L2', 'Behaviors L3', 'Behaviors L4']

  const allBehaviors = data.flatMap((item) =>
    behaviorFields.map((field) => item[field]?.trim()).filter(Boolean)
  )

  // Count occurrences
  const behaviorCounts = allBehaviors.reduce((acc, behavior) => {
    acc[behavior] = (acc[behavior] || 0) + 1
    return acc
  }, {})

  // Sort by frequency and pick top 10
  const topBehaviors = Object.entries(behaviorCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10)
    .map(([behavior]) => behavior)

  // Split into 2 columns
  const leftColumn = topBehaviors.slice(0, 5)
  const rightColumn = topBehaviors.slice(5)

  return (
    <div className="bg-white rounded shadow p-4 w-full max-w-md">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">TOP 10 BEHAVIORS</h2>
      <div className="grid grid-cols-2 gap-4">
        {[leftColumn, rightColumn].map((column, i) => (
          <ul key={i} className="space-y-2">
            {column.map((item, index) => (
              <li key={index} className="text-sm text-gray-800 border-b pb-1 flex items-start">
                <span className="text-lg leading-4 mr-2">•</span> {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}

export default TopBehaviors
